import React, { Component } from 'react';
import BaseLayout from '../../templates/base';
import AgencyEditForm from '../../elements/agencies/form';
import Loading from './../../elements/loading';
import AgenciesAdd from './../../elements/agencies/widget/agencies_add';

class GoalEdit extends Component {
	render() {
		const { agencies, entities} = this.props;
		return (
			agencies.isFetching || entities.isFetching ? <Loading/>:<AgencyEditForm {...this.props} />
		)
	}

	componentWillMount() {
		this.props.reset('agencies.edit');
		this.props.agencyEdit();
	}
}

export default BaseLayout(GoalEdit, {
	title:"Crear Instancia",
	subnav: {
		icon: 'fa fa-map-marker',
		name: 'Administración',
		actions: [
			{
				type: 'element',
				url: null,
				name: 'Agregar',
				element: <AgenciesAdd />
			}
		]
	}
});


// WEBPACK FOOTER //
// ./src/layouts/agencies/create.jsx